import React from "react"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import PersonalUseTable from "./PersonalUseTable"

export default function PersonalUseList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Personal Use")} />
        <PersonalUseTable />
      </div>
    </div>
  )
}
